function scrollTopButtonPosition() {
	var res = resolutionCheck();
	var btnBottom = 240;
    var btnRight = 40;
    var $btn = $('.scroll-top');
	switch (res) {
        case 192:
            // var centerRightMargin = $(document).width() - $('.center--footer').offset().left - $('.center--footer').outerWidth();
			btnBottom = 240;
            btnRight = 40;
            // if ( centerRightMargin > $btn.outerWidth()*2 ) {
            //     btnBottom = 40
            // }
			break;
        case 174:
            btnBottom = 240;
            btnRight = 40;
            break;
        case 144:
            btnBottom = 242;
            btnRight = 40;
            break;
        case 128:
            btnBottom = 250;
            btnRight = 35;
            break;
        case 96:
            btnBottom = 113;
            btnRight = 40;
            break;
        case 64:
            btnBottom = 54;
            btnRight = 31;
            break;
        case 32:
            btnBottom = 10;
            btnRight = 10;
            break;
    }
	
    var scrollBottom = $(document).height() - ( $(window).scrollTop() + $(window).height() );
	if (scrollBottom <= btnBottom - btnRight) {
		$btn.css('position', 'absolute');
		$btn.css('bottom', btnBottom);
		$btn.css('right', btnRight);
	} else {
        $btn.css('position', 'fixed');
        $btn.css('bottom', btnRight);
		$btn.css('right', btnRight);
	}
	
	if (lastScrollTop > 70) {
		$btn.addClass('active');
	} else {
		$btn.removeClass('active');
	}
}